

import Event = createjs.Event;

export class BasicUserEvent extends Event {
    public static LOGGEDIN_TIME_INTERVAL: string = "loggedintimeinterval";
    public static REGISTERED: string = "registered";

    public params: any[];

    constructor(type: string, params: any[] = null, bubbles: boolean = false, cancelable: boolean = false) {
        super(type, bubbles, cancelable);
        this.params = params;
    }
}

